import { send } from 'server';

export const changePin = ({ newAuthenticationPhonePin, currentPin }) => send({
    ID: 35680,
    responses: [35681, 35682],
    description: 'Change pin',
    newAuthenticationPhonePin,
    currentPin
});
